module.exports = __webpack_public_path__ + "assets/img/display.c62fe0a4.svg";